import { useState } from "react";
import { Globe } from "lucide-react";

const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "zh-CN", label: "中文 (简体)" },
  { code: "zh-TW", label: "中文 (繁體)" },
  { code: "ko", label: "한국어" },
  { code: "fa", label: "فارسی" },
  { code: "sv", label: "Svenska" },
  { code: "ja", label: "日本語" },
  { code: "fr", label: "Français" },
];

const getCurrentLang = () => {
  const m = document.cookie.match(/googtrans=\/en\/([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "en";
};

const clearGoogTransCookies = () => {
  const expired = "expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  document.cookie = `googtrans=; ${expired}`;
  const parts = window.location.hostname.split(".");
  for (let i = 0; i < parts.length - 1; i++) {
    const domain = parts.slice(i).join(".");
    document.cookie = `googtrans=; ${expired}; domain=${domain}`;
    document.cookie = `googtrans=; ${expired}; domain=.${domain}`;
  }
};

export const LanguageSwitcher = () => {
  const [lang, setLang] = useState(getCurrentLang);

  const applyLang = (code) => {
    setLang(code);
    if (code === "en") {
      clearGoogTransCookies();
      window.location.reload();
      return;
    }
    const combo = document.querySelector(".goog-te-combo");
    if (combo) {
      combo.value = code;
      combo.dispatchEvent(new Event("change"));
      document.cookie = `googtrans=/en/${code}; path=/`;
    } else {
      document.cookie = `googtrans=/en/${code}; path=/`;
      window.location.reload();
    }
  };

  return (
    <div
      data-testid="language-switcher"
      className="notranslate flex items-center gap-1 rounded-full border-2 border-cyan-300 bg-white pl-2 pr-0.5 py-0.5 shadow-[0_0_10px_rgba(6,182,212,0.25)] transition-colors hover:border-pink-400"
      style={{ transitionProperty: "border-color, box-shadow" }}
    >
      <Globe size={13} className="shrink-0 text-pink-500" />
      <select
        data-testid="language-select"
        aria-label="Translate this survey"
        value={lang}
        onChange={(e) => applyLang(e.target.value)}
        className="lang-select max-w-[86px] cursor-pointer rounded-full bg-white py-1 pr-0.5 text-[11px] font-semibold text-slate-800 outline-none"
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label}
          </option>
        ))}
      </select>
    </div>
  );
};
